<template>
  <div class="card">
    <div style="display: flex;
      justify-content: flex-end; gap: 5px; align-items: center;">
      <!--<i style="cursor: pointer;"
        class="opacity-10 ni ni-active-40"
        aria-hidden="true"
        @click="selectTeam()"
      ></i>-->
      <i style="font-size: 1.5rem; cursor: pointer;"
        class="opacity-10 ni ni-fat-remove"
        aria-hidden="true"
        @click="deleteTeam()" data-bs-toggle="modal" data-bs-target="#idDeleteTeam"
      ></i>
    </div>
    
    <div class="p-3 pt-0 text-center card-body">
      <h6 class="mb-0 text-center">{{ title }}</h6> 
      <hr class="my-3 horizontal dark" />
      <h5 class="mb-0" title="emails in team">{{ value }}</h5> <span> saved emails</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DefaultInfoCard",
  props: {
    icon: {
      type: [String, Object],
      required: true,
      component: {
        type: String,
      },
      background: {
        type: String,
      },
      default: () => ({
        background: "bg-white",
      }),
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    token: {
      type: [String],
      default: "",
    },
  },
  mounted() {
    
  },
  methods: {
    deleteTeam() {
      this.$emit("delete", this.title, this.token)
    },

    selectTeam() {
      this.$emit("select", this.token)
    }
  }
};
</script>
